import { generateTestId } from "@client-shared";

export const setSalesChartTestId = (identifier: string): string => generateTestId("SalesChart", identifier);

// Specific element testIds
export const setSalesChartContainerTestId = (): string => setSalesChartTestId("container");

export const setSalesChartTitleTestId = (): string => setSalesChartTestId("title");
